import React from 'react'
import RoundResultsPage from '../../results/RoundResultsPage'
import ContentStretcher from './ContentStretcher'
import { data as fakePreviewData } from '../../results/data/fakePreviewData'
import Clickable from '../../../atoms/clickable/Clickable'
import HoverableIcon from '../../../atoms/icon/HoverableIcon'
import Icon from '../../../atoms/icon/Icon'
import { DraggableProvidedDragHandleProps } from 'react-beautiful-dnd'

export const THUMBNAIL_COLUMN_WIDTH = 310
export const THUMBNAIL_WIDTH = THUMBNAIL_COLUMN_WIDTH - 20
export const RENDERED_DIMENSIONS = { width: 1189, height: 800 }

interface Props {
  disabled?: boolean
  layout: API.ReportingTemplateLayoutResponse
  onLayoutUpdate?: (layoutId: string, data: API.ReportingTemplateLayoutUpdateRequest) => void
  dragHandleProps?: DraggableProvidedDragHandleProps
  data?: ModelAPI.Reporting.ReportingResults
  showHeader?: boolean
  showTeamPositions?: boolean
  overlay?: React.ReactNode
  roundNumber?: number
}

const ReportingPagePreviewTile: React.FC<Props> = ({
  disabled,
  layout,
  onLayoutUpdate,
  dragHandleProps,
  data,
  showHeader,
  showTeamPositions,
  overlay,
  roundNumber
}) => {
  return (
    <ContentStretcher
      style={{
        background: '#e1e1e1',
        width: THUMBNAIL_WIDTH,
        height: 195,
        minHeight: 195
      }}
      contentWidth={RENDERED_DIMENSIONS.width}
      contentHeight={RENDERED_DIMENSIONS.height}
    >
      <>
        <div style={{ width: RENDERED_DIMENSIONS.width, height: RENDERED_DIMENSIONS.height, minHeight: RENDERED_DIMENSIONS.height, position: 'absolute' }}>
          <RoundResultsPage
            data={data ?? fakePreviewData}
            roundNumber={roundNumber ?? 3}
            onlyThesePages={[layout.type]}
            hidePagination
            hideHeader={!showHeader}
            hideTeamPositions={!showTeamPositions}
            noAnimations
          />
        </div>
        {(!!onLayoutUpdate || !!dragHandleProps || !!overlay) && <div style={{ width: RENDERED_DIMENSIONS.width, height: RENDERED_DIMENSIONS.height, minHeight: RENDERED_DIMENSIONS.height, position: 'absolute', backgroundColor: !!onLayoutUpdate || !!dragHandleProps ? layout.enabled ? 'rgba(0, 0, 0, 0.4)' : 'rgba(0, 0, 0, 0.6)' : undefined }}>
          {!!onLayoutUpdate && <Clickable disabled={disabled} style={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)'}} onClick={() => !!onLayoutUpdate && onLayoutUpdate(layout.id, { enabled: !layout.enabled }) }>
            <HoverableIcon
              size={32}
              fill='white'
              hoverType={layout.enabled ? 'hidden' : 'eye'}
              type={layout.enabled ? 'eye' : 'hidden'}
            />
          </Clickable>}
          {!!dragHandleProps && <Clickable disabled={disabled} style={{ position: 'absolute', top: '0%', right: '0%', padding: 30 }} {...dragHandleProps}>
            <Icon
              size={16}
              fill='white'
              type='draggable'
            />
          </Clickable>}
          {!!overlay && overlay}
        </div>}
      </>
    </ContentStretcher>
  )
}

export default ReportingPagePreviewTile